import { handleActions } from 'redux-actions';

import { TYPE } from './actions';

const reducer = handleActions(
    {
        // FETCH_TRANSACTIONS
        [TYPE.FETCH_EVENTS_LOADING]: (state) => {
            return {
                ...state,
                loading: true
            };
        },
        [TYPE.FETCH_EVENTS_SUCCESS]: (state, action) => {
            const { content, first, last, size, number } = action.payload;

            return {
                ...state,
                data: content,
                pagination: {
                    first,
                    last,
                    size,
                    page: number
                },
                loading: false
            };
        },
        [TYPE.FETCH_EVENTS_ERROR]: (state, action) => {
            return {
                ...state,
                data: [],
                loading: false,
                error: action.payload
            };
        },

        // RESOLVE_EVENT
        [TYPE.RESOLVE_EVENT_LOADING]: (state) => {
            return {
                ...state,
                resolveEvent: {
                    ...state.resolveEvent,
                    loading: true
                }
            };
        },
        [TYPE.RESOLVE_EVENT_SUCCESS]: (state) => {
            return {
                ...state,
                resolveEvent: {
                    ...state.resolveEvent,
                    loading: false
                }
            };
        },

        //  TOGGLE MODAL
        [TYPE.TOGGLE_MODAL_SUCCESS]: (state, action) => {
            const { payload } = action;

            return {
                ...state,
                modals: {
                    ...state.modals,
                    [payload.modalName]: {
                        active: payload.active,
                        data: payload.data
                    }
                }
            };
        },
    },
    {
        loading: false,
        data: [],
        error: null,
        pagination: {
            first: true,
            last: false,
            size: 30,
            page: 0
        },
        filters: {
            startDate: '',
            endDate: '',
            type: '',
            terminal: '',
            searchQuery: '',
        },
        modals: {
            resolveEvent: {
                active: false,
                data: {}
            }
        },
    }
);

export default reducer;
